import { StyleSheet, Platform } from 'react-native';

const styles: any = StyleSheet.create({
	footer: {
		backgroundColor: '#295670',
		height: 30
	},
	bottomButton: {
		alignSelf: 'center',
		backgroundColor: '#295670',
		paddingVertical: 20,
		flex: 1,
		justifyContent: 'center'
	},
	bottomIcon: {
		color: '#8fbcd6'
	},
	modalStyle: {
		borderRadius: 10,
		width: '90%',
		maxHeight: '95%',
		backgroundColor: 'rgba(0,0,0,0)',
		flex: 0
	}
});
export default styles;
